import {} from "./batches.js";
import {} from "./entities.js";
/**
 * Os setores da fábrica e as ocorrências (F234, refeito na F239).
 *
 * O dono da 4Play, em 06/10, mostrando a grade de papel: cada setor pega a
 * grade, marca embaixo de cada tamanho quantas já fez e leva as feitas para o
 * próximo. A F234 marcava linha por passo numa tabela; a F239 troca isso pela
 * tela do setor: as levas (F230) na etapa dele, a grade por tamanho com o
 * "feito" embaixo, e "mandar as feitas" — que separa a leva sozinho.
 *
 * As listas moram também no contrato e nos CHECKs (0122 e 0124) — o teste de
 * paridade segura as três juntas.
 */
/** Os setores da fábrica, na ordem em que a peça passa. */
export const FACTORY_SECTORS = [
    'impressao',
    'corte',
    'costura',
    'embalagem',
];
/**
 * As etapas que são de cada setor. A etapa de espera ("iniciar impressão",
 * "impresso") é a fila do setor que vem depois dela: o que está ali é o que
 * ele tem para fazer.
 */
export const SECTOR_STAGES = {
    impressao: ['iniciar-impressao', 'imprimindo'],
    corte: ['impresso', 'cortando'],
    costura: ['costurando'],
    embalagem: ['embalando'],
};
/** Para onde o setor manda o que fez. */
export const SECTOR_NEXT_STAGE = {
    impressao: 'impresso',
    corte: 'costurando',
    costura: 'embalando',
    embalagem: 'pronto',
};
export const isFactorySector = (value) => typeof value === 'string' &&
    FACTORY_SECTORS.includes(value);
/** De qual setor é esta etapa; nulo fora da fábrica (atendimento, arte, pronto). */
export const sectorOfStage = (stage) => FACTORY_SECTORS.find((sector) => SECTOR_STAGES[sector].includes(stage)) ??
    null;
/** O "feito" marcado cabe na leva de agora? */
export const checkDone = (cells, entries) => {
    const quantities = new Map(cells.map((cell) => [cell.key, cell.quantity]));
    for (const entry of entries) {
        const quantity = quantities.get(entry.key);
        if (quantity === undefined)
            return 'unknown_cell';
        if (entry.done > quantity)
            return 'over_quantity';
    }
    return null;
};
/**
 * O que o setor manda: as células com alguma feita, limitadas ao que a leva
 * tem. `everything` é a leva inteira feita — aí ela anda, em vez de dividir.
 */
export const doneToSend = (cells, done) => {
    const send = cells.flatMap((cell) => {
        const quantity = Math.min(done.get(cell.key) ?? 0, cell.quantity);
        return quantity > 0 ? [{ ...cell, quantity }] : [];
    });
    const everything = cells.length > 0 &&
        cells.every((cell) => cell.quantity <= 0 || (done.get(cell.key) ?? 0) >= cell.quantity);
    return { cells: send, everything };
};
// ---------------------------------------------------------------------------
// As ocorrências (F234)
// ---------------------------------------------------------------------------
/** Refazer (a peça volta) ou problema (um incidente qualquer). */
export const INCIDENT_KINDS = ['refazer', 'problema'];
/** Onde a ocorrência aconteceu. */
export const INCIDENT_SECTORS = [
    'atendimento',
    'arte',
    'impressao',
    // A prensa entre a impressão e o corte (F278).
    'calandra',
    'corte',
    'costura',
    'embalagem',
    'expedicao',
];
export const INCIDENT_STATUSES = ['aberta', 'resolvida'];
export const isIncidentKind = (value) => typeof value === 'string' &&
    INCIDENT_KINDS.includes(value);
export const isIncidentSector = (value) => typeof value === 'string' &&
    INCIDENT_SECTORS.includes(value);
//# sourceMappingURL=sectors.js.map